export default (state = [], action) => {
  let { type, payload } = action
  switch (type) {
    case 'USER_SUBSCRIPTION_FETCH':
      return payload
    case 'USER_SUBSCRIPTION_CREATE':
      return payload
    case 'USER_SUBSCRIPTION_UPDATE':
      return payload
    case 'USER_SUBSCRIPTION_CHANGES':
      return payload
    case 'USER_SUBSCRIPTION_UPDATE_LS':
      return payload
    case 'USER_SUBSCRIPTION_CHANGES_LS':
      return payload
    case 'LOGOUT':
      return []
    default:
      return state
  }
}
